import Coach from '@/containers/coach/Index';
import Phone from '@/containers/coach/Phone';

import { ROUTE_COACH, ROUTE_COACH_PHONE } from './names';


export default [
    {
        path: '/coach',
        name: ROUTE_COACH,
        component: Coach,
        meta: {
            auth: true,
            title: '我',
        },
    },
    {
        path: '/coach/phone',
        name: ROUTE_COACH_PHONE,
        component: Phone,
        meta: {
            auth: true,
            title: '更换手机',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/coach.js